import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { PaymentsService } from 'src/app/_services/payment.serice';
import { MatDialog } from '@angular/material/dialog';

import * as _ from 'lodash';
import io from 'socket.io-client';
declare const $: any;

@Injectable({
	providedIn: 'root'
})
export class TabitPayService {
	public orderChangedSource = new Subject<void>();
	public orderChanged$ = this.orderChangedSource.asObservable();

	private checkChangedSource = new Subject<void>();
	public checkChanged$ = this.checkChangedSource.asObservable();
	detailsCollapsed:boolean;

	tdOrderTypeMap: any = {
		"Seated": "eatin",
		"Delivery": "delivery",
		"TA": "takeaway"
	};

	constructor(
		public dialog: MatDialog,
		public appService: AppService,
		public entityService: EntityService,
		public generalUtils: GeneralUtilsService,
		public paymentService: PaymentsService,
	) {

	}

	$storage: any = {}
	socket;
	orderFetched: boolean = false;

	start(site) {
		this.orderFetched = true;
		if (site.disableTabitLoginFor && site.disableTabitLoginFor.includes("tabitPay")) {
			this.appService.enableLogin = false;
			delete this.appService.user;
		}
		this.appService.$storage = this.$storage = {
			rosConfig: _.assignIn({
				payments: {},
				messaging: {
					hub: {}
				}
			}, site),
			siteLogoURL: site.logoURL,
			organization: site.organization,
			site: site.config,
			contact: {},
			brand: {
				back: _.get(site.config, 'brandV2.splash_back_img_url.url'),
				logo: _.get(site.config, 'brandV2.splash_back_logo_url.url'),
			}
		}

		if (!this.orderFetched) {
			this.appService.logTemplate('orderFetched', {});
		}
	}

	unloadOrder() {
		if (this.socket) {
			this.socket.disconnect();
			this.socket = null;
		}
		this.appService.$storage = this.$storage = {};
	}

	startOrder(siteId, orderId) {
		return this.loadOrder(siteId, orderId)
			.then(order => {
				this.prepareFixedOrder(order);
				return order;
			})
	}

	loadOrder(siteId, orderId) {
		return this.entityService.getOrderById(siteId, orderId)
			.then(response => {
				const order = this.billToOrderView(response);
				this.linkOrder(order.order_id, order.site_id);
				return order;
			});
	}

	interceptTimeout: any;
	interceptOrderFromSocket(orderOnMessage, options: any = {}) {
		window.clearTimeout(this.interceptTimeout);
		let that = this;

		this.interceptTimeout = setTimeout(o => {
			if (!this.$storage.showPrices && orderOnMessage.billed) {
				this.$storage.enablePay = this.appService.regionArgs.enablePay && this.$storage.order.balanceDue > 0;
				this.$storage.showPrices = true;
			}

			that.interceptOrderFromSocketDelayed(orderOnMessage, options);
		}, 100)
	}

	interceptOrderFromSocketDelayed(orderOnMessage, options: any = {}) {
		let that = this;
		if (!this.$storage.freezeAutoOrderUpdate &&
			this.$storage.order &&
			orderOnMessage &&
			this.$storage.order.order_id === orderOnMessage._id) {

			var actualBalance = orderOnMessage.balance;
			var knownBalance = this.$storage.order.printData.variables.BAL_DUE * 100;
			var closed = !!orderOnMessage.closed;
			let restricted = _.get(orderOnMessage, 'restrictions.bill.restricted', false);
			if (restricted != this.$storage.restricted) this.$storage.wasPrepared = false;

			const checkBalanceChanged = () => {
				return (actualBalance != knownBalance || this.$storage.order?.totals?.totalTips != orderOnMessage.totals?.totalTips || this.$storage.order?.totals?.totalAmount != orderOnMessage.totals.totalAmount);
			}

			const checkDinersChanged = () => {
				return orderOnMessage.diners?.length != this.$storage.order?.diners?.length;
			}
			const dinersChanged = checkDinersChanged();

			const checkPendingItemsChanged = () => {
				return orderOnMessage.pending?.orderedItems?.length != this.$storage.order?._order?.pending?.orderedItems?.length;
			};
			if (checkBalanceChanged() || checkDinersChanged() || checkPendingItemsChanged() || closed != this.$storage.order.closed || restricted != this.$storage.restricted || options.op === 'billed') {
				if (closed) {
					var newOrder = _.cloneDeep(this.$storage.order);
					newOrder.closed = true;
					that.refreshPayOrder(newOrder)
				} else {
					if (dinersChanged) {
						const orderDiners = this.$storage.order.diners;
						const userId = this.appService.user?._id;
						orderOnMessage.diners.forEach((diner) => {
							if (diner.customer != userId && !orderDiners.find(o => o._id == diner._id)) {
								if (diner.name) {
									this.appService.toastrSimple(this.appService.translate('OAT.user_joined_tab', {name: diner.name}), null, 15000);
								}
							}
						});
					}
					this.loadOrder(this.$storage.organization, this.$storage.order.order_id).then(function (newOrder) {
						that.refreshPayOrder(newOrder);
					});
				}
			}
		}
	};

	simulateOrderChange(mode?) {
		this.$storage.wasPrepared = false;
		let restricted = _.get(this.$storage.order, '_order.restrictions.bill.restricted', false);
		_.set(this.$storage.order, '_order.restrictions.bill.restricted', !restricted);
		this.refreshPayOrder(this.$storage.order);

	}

	refreshPayOrder(newOrder, hideRefreshMessage?) {
		let that = this;
		delete that.$storage.freezeAutoOrderUpdate;
		var currentOrder = that.$storage.order;
		this.prepareFixedOrder(newOrder);
		//var wasBalanceChanged = newOrder.balanceDue != currentOrder.balanceDue;
		this.$storage.previousOrder = currentOrder;
		this.orderChangedSource.next();
	}

	// prepare bull for view
	billToOrderView(bill) {
		let that = this;

		const tipBehavior = _.get(bill, 'order.settings.tipBehavior');
		const isTipCalculatedInTotal = tipBehavior == "declared" || tipBehavior == "declaredWithoutVat";

		let balanceDue = bill.printData.variables.BAL_DUE;
		let totalSales = bill.printData.variables.TOTAL_AMOUNT;

		if (isTipCalculatedInTotal) {
			const tipAmount = _.get(bill.printData.variables, 'TOTAL_TIPS', 0);
			totalSales -= tipAmount;
			bill.printData.variables.TOTAL_AMOUNT = totalSales;
		}

		let order = bill.order;
		let appService = this.appService;
		if (!order.deliveryInfo) order.deliveryInfo = {}
		let tabOwner = order.deliveryInfo.tabOrderCreator;

		if (!order.diners || !order.diners.length) {

		} else {

			const colors = [
				'#EC417A',
				'#0CA3A6',
				'#8C6E63',
				'#EF6C00',
				'#A82F63',
				'#00897B',
				'#5D4138',
				'#F6511E',
			];

			let indexOp = 0, isManyDiners = order.diners.length > 3 || order.deliveryInfo.isTabOrder;
			_.each(order.diners, function (diner, index:number) {
				if (diner.tags?.name) {
					prepareDinerName(diner, diner.tags?.name, isManyDiners);
				} else {
					diner.isUnknown = true;
					if (!isManyDiners && appService.user?.name) {
						diner.customer = appService.user?._id;
						prepareDinerName(diner, appService.user?.name, isManyDiners);
					} else {
						diner.name = diner.caption = `-- ${index + 1} --`;
						diner.initials = `${index + 1}`;
					}
				}
				diner.isMe = diner.customer && diner.customer === appService.user?._id;
				diner.isOwner = diner.customer && diner.customer === tabOwner;
				if (diner.isMe) { // || diner.isOwner
					indexOp++;
					if (diner.isMe) {
						diner.background = '#0f5853';
					} else {
						diner.background = '#c09336';
					}
				} else {
					diner.background = colors[(index -indexOp) % colors.length];
				}
				diner.totalItems = 0;
				diner.offers = []
			});
		}

		function prepareDinerName(diner, name: string, isManyDiners) {
			diner.name = name;
			const propArr = name.split(" ");
			diner.initials = propArr[0].substr(0, 1);
			if (propArr[1]) diner.initials += propArr[1].substr(0, 1);
			diner.caption = isManyDiners ? propArr[0] : diner.name;
		}

		let defaultDinerId, defaultDiner = {
			diner: -999,
			name: 'W',
			initials: 'W',
			background: '#808080',
			totalItems: 0,
			isWaiter: true,
			icon: 'bell_concierge',
			offers: []
		};
		if (bill.order.orderType == "Seated") {
			defaultDinerId = -999;
		} else {
			defaultDinerId = _.get(order, "diners[0]._id");
		}

		let offersDiners = {}
		_.each(order.orderedOffers, function (offer) {
			offer._isRefund = offer.amount < 0;
			offer.$$amount = Math.abs(offer.amount);
			let items = [];
			_.each(offer.orderedItems, function (itemId) {
				let item: any = _.find(order.orderedItems, { _id: itemId });
				let hasSummary, summary: any = {}, _arr;
				if (item.selectedModifiers && item.selectedModifiers.length) {
					_arr = [];
					_.each(item.selectedModifiers, function (mod) {
						if (!mod.isDefault) {
							hasSummary = true;
							_arr.push(mod.name);
						}
					});
					summary.modWith = _arr.join(', ');
				}
				if (item.removedModifiers && item.removedModifiers.length) {
					hasSummary = true;
					_arr = [];
					_.each(item.removedModifiers, function (o) { if (o.name) _arr.push(o.name) });
					summary.modWithout = _arr.join(', ');
				}
				if (hasSummary || item.note) item._summary = summary;
				items.push(item);
			});
			if (items.length == 1 && !items[0]._summary) offer._hideItems = true;
			offer._orderedItems = items;

			// ----------------------------------------------------------->

			if (!offer.diner && !offer.adHocOffer) offer.diner = defaultDinerId;
			let diner = _.find(order.diners, { _id: offer.diner });
			if (!diner) diner = defaultDiner;
			if (diner) {
				if (offer.amount) diner.totalItems += offer.amount;
				if (diner.offers)diner.offers.push(offer);
				let _offerDiners = offersDiners[`${offer.offer}_${offer.onTheHouse ? '0' : offer.amount}`];
				if (!_offerDiners) {
					offersDiners[`${offer.offer}_${offer.onTheHouse ? '0' : offer.amount}`] = {
						amount: offer.amount,
						name: offer.name,
						onTheHouse: offer.onTheHouse != null,
						discount: offer.onTheHouse ? offer.amount : 0,
						count: 1,
						diners:[{
							diner: offer.diner,
							name: diner.name,
							isMe: diner.isMe,
							initials: diner.initials,
							background: diner.background,
							icon: diner.icon,
							count: 1
						}]
					};
				} else {
					++_offerDiners.count;
					_offerDiners.amount += offer.amount;
					if (offer.onTheHouse) offer.discount += offer.amount;
					let _offerDiner = _offerDiners.diners.find(o => o.diner === offer.diner);
					if (!_offerDiner) {
						_offerDiners.diners.push({
							diner: offer.diner,
							name: diner.name,
							isMe: diner.isMe,
							initials: diner.initials,
							background: diner.background,
							icon: diner.icon,
							count: 1
						});
					}else {
						++_offerDiner.count;
					}
				}
			}
		});

		let pendingOffers;
		if (_.get(bill.order.pending,'orderedOffers[0]')) {
			pendingOffers = bill.order.pending.orderedOffers.map(offer => {
				let diner = _.find(order.diners, { _id: offer.diner });
				if (!diner) diner = defaultDiner;
				return {...offer, _diner: {
						diner: offer.diner,
						name: diner.name,
						isMe: diner.isMe,
						initials: diner.initials,
						background: diner.background,
						icon: diner.icon,
						count: 1
					}
				}
			})
		}

		// auto gratuity ---------------------------------->

		let autoGratuity: any = {
			amount: 0,
			name: null
		}
		_.each(order.tips, (tip) => {
			if (tip.type == 'auto') {
				autoGratuity.amount += tip.amount / 100;
				if (!autoGratuity.name) autoGratuity.name = tip.name;
			}
		});
		if (!autoGratuity.amount) autoGratuity = null;

		// payments --------------------------------------->

		let billPayments = _.filter(bill.order.payments, pa => {
			if (pa.isPayout) {
				let payment: any = _.find(bill.order.payments, { _id: pa.refundedPaymentId });
				if (payment) {
					payment.amount -= pa.amount;
					if (pa.auxAmount) {
						if (!payment.auxAmount) payment.auxAmount = 0;
						payment.auxAmount -= pa.auxAmount;
					}
				}
				return false;
			}
			return true;
		});

		let payments = [], totalTips = 0, totalPayments = 0;
		_.each(billPayments, payment => {
			if (!payment.paid) return;

			let customerName = payment.customerDetails?.name;
			if (!customerName || !this.appService.isAlphabetic(customerName)) customerName = 'waiter_payment';

			let pm = _.find(payments, { name: customerName });
			if (!pm) {
				pm = { name: customerName, total: 0, tip: 0, _id: payment._id }
				payments.push(pm);
			}
			pm.total += (payment.amount / 100);
			totalPayments += pm.total;
			if (payment.auxAmount) {
				pm.tip += (payment.auxAmount / 100);
				totalTips += pm.tip;
			} else if (payment.auxIntent?.quantity) {
				pm.tip += (payment.auxIntent.quantity / 100);
				totalTips += pm.tip;
			}
		});

		var orderView: any = {
			order_id: bill.order._id,
			site_id: bill.organizationId,
			balanceDue: balanceDue,
			currentBalance: bill.printData.variables.TOTAL_PAYMENTS,
			itemsTotal: totalSales,
			originalTotalForPayment: (bill.order.totals.originalTotalForPayment && bill.order.totals.originalTotalForPayment / 100) || totalSales,
			__v: bill.order.__v,
			total: totalSales,
			fees: (() => {
				if (!['US', 'AU'].includes(this.appService.region)) return 0;
				return _.sumBy(_.get(order.fees, 'applied', []), 'amount') / 100;
			})(),
			grandTotal: balanceDue,
			printData: bill.printData,
			autoGratuity: autoGratuity,
			closed: !!bill.order.closed,
			orderType: bill.order.orderType,
			mode: this.tdOrderTypeMap[bill.order.orderType],
			isBilled: _.get(bill.order, "billed.at") != null,
			diners: order.diners,
			source: order.source,
			payments: payments,
			totalTips: totalTips,
			totalPayments: totalPayments,
			totals: order.totals,
			dinersCount: order.diners && order.diners.length,
			lifeCycle: bill.order.lifeCycle,
			authorization: _.get(order.authorizationHolds, '[0]'),
			_order: order,
			canPay: true,
			pendingOffers
		}

		const tableOrdering = this.$storage.site?.tableOrdering;
		if (!order.deliveryInfo.isTabOrder) {
			if (tableOrdering && tableOrdering.enabled && tableOrdering.orderWithTableBehavior === "onTable") {
				_.set(order, 'deliveryInfo.isTabOrder', true);
				if (orderView.authorization) {
					orderView.enablePayWithAuth = true;
					order.deliveryInfo.isTabOrderPreAuth = true;
				}
			}
		}

		if (order.deliveryInfo.isTabOrder) {
			orderView.isTabOrder = true;
			orderView.offerDiners = offersDiners;
			orderView.tabName = order.deliveryInfo.tabName;
			orderView.isTabOrderPreAuth = order.deliveryInfo.isTabOrderPreAuth;
			orderView.tableNO = bill.printData.variables.TABLE_NO;
			orderView.isTabOwner = order.deliveryInfo.tabOrderCreator == this.appService.user?._id;
			orderView.reviewItemsBeforeSending = order.deliveryInfo.reviewItemsBeforeSending;

			if (pendingOffers && !orderView.isTabOwner) {
				orderView.pendingOffers = pendingOffers.filter(offer => offer._diner.isMe);
				if (!orderView.pendingOffers.length) orderView.pendingOffers = null;
			}

			if (orderView.authorization) {
				if (orderView._order?.deliveryInfo?.fixedPreAuthAmount) {
					orderView.tabLimitUnlimitted = true;
				} else {
					orderView.tabLimit = _.round(_.get(orderView.authorization, 'amount', 0) / 100, 2);
				}
			} else if (orderView.isTabOrderPreAuth) {
				orderView.isTabClosed = true;
			}
			orderView.canPay = orderView.isTabOwner || !orderView.isTabOrderPreAuth || this.appService.regionArgs.allowNonDepositPayments ;
		}

		let checks = bill.order.checks;
		if (!_.get(checks, [1])) checks = null; // this.appService.region == "IL" ||
		else {
			orderView.checks = checks;
			orderView.orderedOffers = bill.order.orderedOffers;
			_.each(checks, check => {
				check.$$total = _.get(check, 'totals.totalAmount', 0) / 100;
				check.originalTotalForPayment = _.get(check, 'totals.originalTotalForPayment', 0) / 100;
				check.$$paid = (_.get(check, 'totals.totalPayments', 0)) / 100; // - _.get(check, 'totals.totalTips', 0))
				check.$$balanceDue = check.$$total - check.$$paid;
				check.$$discounts = _.get(check, 'totals.discounts.order', 0) / 100 * -1;
				check.$$tip = (_.get(check, 'totals.totalTips', 0) - _.get(check, 'totals.totalServiceCharge', 0));
				check.$$fees = (() => {
					if (this.appService.region != "US") return 0;
					return _.sumBy(_.get(check.fees, 'applied', []), 'amount');
				})();
				let _payments = [];
				_.each(check.payments, payment => {
					let _payment: any = _.find(bill.order.payments, { _id: payment.paymentId });
					if (_payment) {
						let customerName = _.get(_payment, 'customerDetails.name', 'waiter_payment');
						let pm = _.find(_payments, { name: customerName });
						if (!pm) {
							pm = { name: customerName, total: 0, tip: 0, _id: _payment._id }
							_payments.push(pm);
						}
						pm.total += (_payment.amount / 100);
						if (_payment.auxAmount) pm.tip += (_payment.auxAmount / 100);
					}
				});
				check.payments = _payments;
				check.wasPayed = false;
			});
		}

		return orderView;
	}

	canAddItems(order) {
		let $storage = this.$storage;
		const tpConfig = _.get($storage.site, 'tabitpay');
		if (!tpConfig.enableAddItems) return false;
		let timeSlot;
		if (tpConfig.addItems_schedule) timeSlot = _.find($storage.site.timeslots, { _id: tpConfig.addItems_schedule });
		if (!timeSlot) timeSlot = $storage.site.workHours;
		if (!this.generalUtils.isTimeslotsActive(timeSlot)) return false;
		if ($storage.order.isTabOrderPreAuth) {
			if ($storage.order.tabLimitUnlimitted) return true;
			else if (!$storage.order.tabLimit) return false;
		}
		return true;
	}

	hasGeneralItem(order) {
		let giOffer = order.orderedOffers.find(o => o.adHocOffer && o.amount);
		return giOffer != null;
	}

	prepareFixedOrder(newOrder) {
		let $storage = this.$storage;
		$storage.orderMode = 'fixedorder';
		$storage.orderValid = true;
		if ($storage.order) {
			newOrder.address = $storage.order.address;
			newOrder.contact = $storage.order.contact;
			newOrder.$ccinfo = $storage.order.$ccinfo;
		}

		$storage.order = newOrder;
		var printData = $storage.order.printData || { variables: {} };

		if (!$storage.wasPrepared) {
			$storage.wasPrepared = true;

			$storage.enablePartialPayment = true;
			$storage.enableGratuity = true;
			//if (this.appService.appConfig.isDev) $storage.enableGratuity = false;

			$storage.enablePassOrder = true;
			$storage.orderSource = newOrder.source;
			$storage.enableAddItems = false;
			let settings = $storage.site.settings || {}
			switch (newOrder.orderType) {
				case "Seated"://eatin
					$storage.gratuities = _.get(settings.gratuities, [0]) ? settings.gratuities : this.appService.region == "US" ? [18, 20, 22] : [12, 15, 18, 20];
					//$storage.requiereCreditSign = true;
					$storage.disableCashPayment = true;
					$storage.showPrices = this.appService.urlParams.price || newOrder.isBilled || !settings.hideTabitPayPricesBeforeBill;
					$storage.enableAddItems = this.canAddItems(newOrder);
					break;
				case "TA"://takeaway
					$storage.enableGratuity = _.get($storage.site, 'takeaway.enableGratuity') == true;
					if (this.appService.region == 'US') {
						$storage.gratuities = [18, 20, 22];
					} else {
						$storage.gratuities = _.isArray(settings.courierGratuities) && settings.courierGratuities.length ? settings.courierGratuities : [10, 15, 20, 25];;
					}
					$storage.isTA = true;
					$storage.showPrices = true;
					$storage.isOTC = true;
					printData.$orderer = printData.variables.ORDERER_NAME;
					if (this.appService.appConfig.isDev || this.appService.appConfig.env == 'il-int') $storage.enableAddItems = this.canAddItems(newOrder);
					break;
				case "OTC":
					let lifeCycleName = _.get(newOrder.lifeCycle, 'name');
					if (lifeCycleName == 'opened' || lifeCycleName == 'fired' || this.hasGeneralItem(newOrder._order)) {
						$storage.enableGratuity = true;
						$storage.gratuities = ["US", "AU"].includes(this.appService.region) ? [18, 20, 22] : _.isArray(settings.gratuities) && settings.gratuities.length ? settings.gratuities : [12, 15, 18, 20];
						$storage.showPrices = true;
						$storage.isOTC = true;
						printData.$orderer = printData.variables.ORDERER_NAME;
					}
					break;
				case "Delivery"://delivery
					$storage.enableGratuity = _.get($storage.site, 'delivery.enableGratuity') == true;
					$storage.gratuities = _.isArray(settings.courierGratuities) && settings.courierGratuities.length ? settings.courierGratuities : [10, 15, 20, 25];
					$storage.showPrices = true;
					$storage.isDelivery = true;

					$storage.isOTC = true;
					var arrAddress = [];
					_.each(['ORDERER_ADDRESS_STREET', 'ORDERER_ADDRESS_HOUSE', 'ORDERER_ADDRESS_CITY'], function (att) {
						var v = printData.variables[att];
						if (v) {
							if (att == 'ORDERER_ADDRESS_CITY' && arrAddress.length) v = ", " + v;
							arrAddress.push(v);
						}
					});
					$storage.$deliveryAddress = arrAddress.join(" ");
					$storage.$orderer = printData.variables.ORDERER_NAME;
					$storage.order.address = {
						formatted_address: printData.$deliveryAddress,
						entrance: printData.variables.ORDERER_ADDRESS_ENTRANCE,
						floor: printData.variables.ORDERER_ADDRESS_FLOOR,
						appartment: printData.variables.ORDERER_ADDRESS_APARTMENT
					}
					break
			}

			// fix gratuities
			_.remove($storage.gratuities, val => { return isNaN(val as any) || Number(val) <= 0 });
			$storage.gratuities = _.map($storage.gratuities, val => { return Math.ceil(Number(val)) });
			if ($storage.gratuities.length > 4) $storage.gratuities = $storage.gratuities.sort().slice(0, 4);

			// ------------------------------------------------------------------------------------------------->
			// payment options
			// ------------------------------------------------------------------------------------------------->

			this.paymentService.prepareConfigPayments($storage, $storage.site.paymentAccounts, 'tabitPay', { timeslots: $storage.site.timeslots, enableTenbis: settings.enableTenbis, });

		} else {
			if (newOrder.isBilled) $storage.showPrices = true;
		}

		if (_.get(newOrder, '_order.restrictions.bill.restricted')) {
			$storage.restricted = true;
			$storage.enablePay = false;
			$storage.showPrices = false;
		} else {
			$storage.restricted = false;
			$storage.enablePay = this.appService.regionArgs.enablePay && $storage.showPrices && $storage.order.balanceDue > 0;
		}

		//prepare fixed order print data
		var printOffers = _.get(printData, 'collections.ORDERED_OFFERS_LIST', []);
		$storage.hasOffers = printOffers.length > 0;

		_.each(printOffers, (pOffer) => {
			let offer = pOffer;
			let items = pOffer.ALL_ORDERED_ITEMS;
			for (let i = 0; i < items.length; i++) {
				let pItem = items[i];
				var pMods = pItem.MODIFIERS_LIST;
				var hasMods = false;
				var hasModsExclude = false;
				_.each(pMods, function (pMod) {
					pMod._show = false;
					if (pMod.EXCLUDED) {
						hasModsExclude = true;
						pMod._name = pMod.MODIFIER_NAME;
						pMod._show = true;
					} else if (!pMod.IS_DEFAULT_SELECTED && !pMod.FORMATION) {
						pMod._name = pMod.MODIFIER_NAME;
						pMod._show = true;
						hasMods = true;
					} else if (pMod.MODIFIER_PRICE && pMod.MODIFIER_PRICE > 0) {
						pMod._name = pMod.MODIFIER_NAME;
						pMod._show = true;
						hasMods = true;
					}
				});
				pItem._showItem = false;
				if (hasMods) {
					pItem._hasMods = true;
				};
				if (hasModsExclude) {
					pItem._hasModsExclude = true;
				};
				if (hasMods || hasModsExclude) {
					pItem._showItem = true;
				};
			};
		});
	};


	// --------------------------------------------------------------------------------------------------------------->
	// SOCKET UTILS
	// --------------------------------------------------------------------------------------------------------------->

	linkOrder(orderId, organization) {
		let that = this;
		if (!this.socket && this.$storage.rosConfig.messaging.hub.url) {
			let wsUrl = this.$storage.rosConfig.messaging.hub.url + "/events";
			that.socket = io(wsUrl, {
				transports: ['websocket']
			});
			that.socket.on('connect', function () {
				//console.log('socket io connected');
				that.getPublicToken(organization).then(function (token) {
					that.socket.emit('order', { accessToken: token, orderId: orderId });
				});
			});
			that.socket.on('order', function (data) {
				that.interceptOrderFromSocket(data.content, data.headers);
				//console.log('Got event:', JSON.stringify(data));
			});
			that.socket.on('disconnect', function () {
				//console.log('socket io dis-connected');
			});
		}
	}

	getPublicTokenData(organization) {
		let authData = {
			grant_type: 'client_credentials',
			client_id: 'urfoxj8ymmz2bbfolofq4xsjr9psc3q7ii76b2n3',
			scope: organization ? `online-account organization/${organization}` : 'online-account'
		};

		return this.servicePost({ url: '/oauth2/token', data: authData }).then(function (res) {
			return res;
		})
	}

	getPublicToken(organization) {
		return this.getPublicTokenData(organization).then(function (ret) {
			return ret && ret.access_token;
		})
	}

	// --------------------------------------------------------------------------------------------------------------->
	// GRATUITY UTILS
	// --------------------------------------------------------------------------------------------------------------->

	fixGratuity() {
		var gratuity = this.$storage.order.gratuity;
		var total = this.$storage.order.grandTotal;
		var grandTotalPlusTip = total;
		var gratuityAmount = 0;
		if (gratuity) {
			if (gratuity.type == 'p') {
				var pVal = gratuity.percent || 0;
				if (pVal && gratuity.amount) {
					gratuity.amount = this.roundGratuity(gratuity.amount);
				} else {
					gratuity.amount = this.calculateGratuityFromPercentage(pVal);// _.round(total * (pVal / 100), MetaService.local.decimals);
				}
				grandTotalPlusTip += gratuity.amount;
				gratuityAmount = gratuity.amount;
			} else if (gratuity.type == 'm' || gratuity.type == 'mm') {
				if (!gratuity.amount || isNaN(gratuity.amount)) {
					gratuity.amount = 0;
					gratuity.percent = 0;
				} else {
					gratuityAmount = _.round(gratuity.amount, 2);
					grandTotalPlusTip += gratuity.amount;
					gratuity.percent = gratuity.amount / total * 100
				}
			}
		}
		;
		this.$storage.order.gratuityAmount = gratuityAmount;
		this.$storage.order.grandTotalPlusTip = grandTotalPlusTip;
	};


	calculateGratuityFromPercentage(pVal, totalAmount?) {
		var total = totalAmount || this.$storage.order.grandTotal;
		var unroundedGratuity = total * (pVal / 100);
		unroundedGratuity = Math.max(unroundedGratuity, 1);
		return this.roundGratuity(unroundedGratuity);
	}

	roundGratuity(unroundedGratuity) {
		var minDenom = _.get(this.$storage.rosConfig.currencySettings, 'minimalTipDenomination', 100);
		minDenom = minDenom / 100;

		var roundedGratuity = _.round(unroundedGratuity / minDenom) / (1 / minDenom);
		return _.round(roundedGratuity, 2);
	}

	// --------------------------------------------------------------------------------------------------------------->
	// PAYMENT UTILS
	// --------------------------------------------------------------------------------------------------------------->

	processPayment(args: any = {}) {
		const phone = this.$storage.site.phone;
		if (this.$storage.orderClosed) {
			return Promise.reject({
				type: 'SERVER_ERROR',
				message: this.appService.translate("MESSAGES.SERVER_ERROR", { phone: phone })
			});
		}
		const havePayments = args.ccinfo || args?.splitPayments?.length;
		if (!havePayments) {
			return Promise.reject({
				type: 'SERVER_ERROR',
				message: this.appService.translate("MESSAGES.PROBLEM_IN_PAYMENT_INPUT", { phone: phone })
			});
		}

		if (!args.ccinfo && args.splitPayments && args.splitPayments.length === 1) args.ccinfo = args.splitPayments[0];

		if (this.$storage.check) {
			args.ccinfo.checkId = this.$storage.check._id;
		}

		const parsedOrder = this.getPreparedOrder(this.$storage, false, args);
		this.$storage.order.haveErrors = false;

		const addPaymentToWallet = args.updatePaymentInfo;
		let paymentsAddedOnThisCall = [];
		this.$storage.freezeAutoOrderUpdate = true;

		return new Promise((resolve, reject) => {
			this.createOrLoadOrder(parsedOrder)
				.then((resultOrder) => {
					const ptp = _.cloneDeep(args.ccinfo);
					if (!ptp.amount) ptp.amount = parsedOrder.balanceDue + args.gratuityAmount;
					ptp.customerDetails = parsedOrder.orderer;
					ptp.tip = args.gratuityAmount;
					ptp.addPaymentToWallet = addPaymentToWallet;
					return this.processSinglePayment(ptp, resultOrder, paymentsAddedOnThisCall, this.$storage.order.total)
						.then(() => {
							return resultOrder;
						});
				}).then((resultOrder) => {
					let handoffData: any = {
						status: 'ready',
						includedPayments: paymentsAddedOnThisCall.map((ap) => {
							return ap._id
						})
					};

					if (this.$storage.orderSource == "webCallCenter") {
						return this.servicePost({
							url: '/online-shopper/orders/' + resultOrder._id + '/handoff',
							data: handoffData,
							loadingCaption: 'PAYMENT_IN_PROGRESS'
						}).then(() => {
							return resultOrder
						});
					} else {
						return resultOrder;
					}
				}).then((resultOrder) => {
					if (this.$storage.orderMode != "fixedorder") {
						this.$storage.orderClosed = true;
					}
					this.$storage.order.reference = resultOrder.number;
				}).then(() => {
					resolve({});
				}).catch((err) => {
					console.log('err', err);
					if (err && err.type) {
						if (err.type == 'CANCELED') {
							reject(err);
						} else if (err.order && (err.type === 'ORDER_RELOAD_NEEDED')) {
							//reconnect socket + update subject event
							this.loadOrder(this.$storage.organization, err.order._id).then(newOrder => {
								newOrder["grandTotalPlusTip"] = newOrder.balanceDue;
								this.refreshPayOrder(newOrder);
								reject(err);
							});
						} else {
							this.handlePartialPaymentsError(err).then((revisedErr) => {
								reject(revisedErr);
							});
						}
					}
					else {
						const formattedError = this.paymentService.formatError(err, this.$storage);
						reject(formattedError);
					}
				}).then(res => {
					delete this.$storage.freezeAutoOrderUpdate;
				});
		});
	}

	processSinglePayment(paymentInfo, resultOrder, paymentsAddedOnThisCall, total?) {
		let savePayment = null;
		let parsedPayment;
		let that = this;
		return Promise.resolve()
			.then(() => {
				const releaseOrder = paymentInfo.releaseOrder;
				parsedPayment = that.generalUtils.getPreparedPayment(paymentInfo);

				if (total) {
					parsedPayment.orderTotal = total * 100;
				}

				if (!parsedPayment.$$isExternal && paymentInfo.addPaymentToWallet) {
					savePayment = that.generalUtils.ccInfoToWalletPayment(paymentInfo);
				}
				delete paymentInfo.addPaymentToWallet;

				return that.paymentService.processNotCashPayment(this.$storage, resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall);

			}).then((resultOrder: any) => {
				if (that.appService.cachedPaymentInfo) {
					that.appService.cachedPaymentInfo.verificationCode = resultOrder.verificationCode;
					that.appService.cachedPaymentInfo.deviceId = that.appService.clientId;
				}

				// Cibus/10bis
				if (savePayment) {
					savePayment.verificationCode = resultOrder.verificationCode;
					savePayment.deviceId = that.appService.clientId;
					return that.entityService.addPaymentMethodToWallet(savePayment)
						.then(() => {
							this.createUserWalletPms();
							return resultOrder;
						});
				}
				return resultOrder;
			})
	}


	createUserWalletPms() {
		this.paymentService.createUserWalletPms(this.$storage);
	}


	// --------------------------------------------------------------------------->
	// --------------------------------------------------------------------------->
	// --------------------------------------------------------------------------->


	getPreparedOrder = function getPreparedOrder($storage, _clean, options) {
		var order = $storage.order;
		var site = $storage.order.branch;
		return {
			orderType: this.generalUtils.CONSTS.tdTypeMap[order.mode],
			serviceType: this.generalUtils.CONSTS.tdServiceTypeMap[order.mode],
			orderer: this.generalUtils.getCustomer($storage, true),
			table: order.table,
			order_id: $storage.order.order_id,
			__v: $storage.order.__v,
			balanceDue: $storage.order.balanceDue,
			balance: Math.round($storage.order.balanceDue * 100)
		}
	}

	createOrLoadOrder(parsedOrder) {
		let that = this;
		if (parsedOrder.order_id) {
			return that.serviceGet({
				url: "/online-shopper/orders/" + parsedOrder.order_id,
				loadingCaption: 'LOADING_ORDER'
			}).then(function (loadedOrder) {
				if (loadedOrder.balance !== parsedOrder.balance) {
					throw {
						type: 'ORDER_RELOAD_NEEDED',
						message: that.appService.translate("MESSAGES.ORDER_RELOAD_NEEDED"),
						order: loadedOrder
					};
				}
				loadedOrder.source = 'tabitPay';
				return loadedOrder;
			});
		}
	}

	handlePartialPaymentsError(err) {
		let that = this;
		return new Promise((resolve, reject) => {
			if (err.type === 'PARTIAL_PAYMENT_ERROR') {
				that.servicePost({
					url: '/online-shopper/orders/' + err.order._id + '/handoff',
					data: { status: 'attendanceRequired' },
					loadingCaption: 'PAYMENT_IN_PROGRESS'
				})
					.then(function () {
						err.orderClosed = true;
						if (that.$storage.orderMode != "fixedorder")
							that.$storage.orderClosed = true;
						that.$storage.order.reference = err.order.number;
						that.$storage.order.haveErrors = true;
						resolve(err);
					})
					.catch(function (tmpErr) {
						console.log("Error on release bad order", tmpErr);
						err.orderClosed = true;
						if (that.$storage.orderMode != "fixedorder")
							that.$storage.orderClosed = true;
						that.$storage.order.reference = err.order.number;
						that.$storage.order.haveErrors = true;
						resolve(err);
					});
			} else resolve(err);
		});
	}


	serviceGet(params) {
		return this.entityService.get(params.url, params.data, { 'ros-organization': this.$storage.organization });
	}

	servicePost(params, enableRecaptcha?: boolean) {
		return this.entityService.post(params.url, params.data, { 'ros-organization': this.$storage.organization }, enableRecaptcha);
	}

	//------------------------------------------------------------------------------------------>
	// tab order
	//------------------------------------------------------------------------------------------>

	canCreateTabOrder(config) {
		return this.generalUtils.canCreateTabOrder(config);
	}

	canCreateEatinOrder() {
		return this.generalUtils.canCreateEatinOrder(this.$storage.site);
	}

	async createTabOrder(args?) {
		return this.paymentService.createTabOrder(this.$storage.site, args);
	}
	async addPaymentAuthorization(amount) {
		return this.paymentService.addPaymentAuthorization(this.$storage.site, this.$storage.order._order, amount);
	}

	async checkTabOrderDiner() {
		if (!this.appService.user || !this.$storage.order?.isTabOrder) return;
		let orderDiner = this.$storage.order.diners.find(o => o.customer == this.appService.user._id);
		if (orderDiner) return;
		try {
			let response = await this.servicePost({
				url: `/online-shopper/orders/${this.$storage.order.order_id}/diners`,
				data: {
					"diner": {
						"name": this.appService.user.name
					}
				},
			});
		} catch (e) {

		}
	}


	async approvePending(payload){
		let url = `/online-shopper/orders/${this.$storage.order.order_id}/order`;
		try {
			let response = await this.entityService.post(url, payload, { 'ros-organization': this.$storage.site._id });
			let delResponse = await this.deletePending(payload);
			return {response, delResponse};
		} catch (err) {
			throw (err);
		}
	}
	async deletePending(_payload){
		let url = `/online-shopper/orders/${this.$storage.order.order_id}/remove-pending`;
		const payload = {
			orderedItems: _payload.orderedItems.map(oi => oi._id),
			orderedOffers: _payload.orderedOffers.map(oo => oo._id)
		}
		try {
			let response = await this.entityService.post(url, payload, { 'ros-organization': this.$storage.site._id });
			return response;
		} catch (err) {
			throw (err);
		}
	}

}
